module.exports = __webpack_public_path__ + "mrstaticmedia/1-2@2x.3e15699f.png";